import _styled from "styled-components";
const _excluded = ["style", "className", "typographyStyle", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-react-theme';
/**
 * This component adds a hidden "before" element to text, to verify space is kept when changing font weight.
 */
const TypographyWidthHolder = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      style,
      className,
      typographyStyle,
      children
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return typeof children === 'string' ? /*#__PURE__*/React.createElement(_StyledP, _extends({}, props, {
    ref: ref,
    className: className,
    $_css: [{
      margin: 0,
      padding: 0,
      '&:before': _objectSpread({
        content: `"${children}"`,
        display: 'block',
        color: 'transparent',
        visibility: 'hidden',
        overflow: 'hidden',
        height: 0
      }, typographyStyle)
    }, style]
  }), children) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
});
TypographyWidthHolder.displayName = 'TypographyWidthHolder';
TypographyWidthHolder.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Typography style we want to save space for */
  typographyStyle: PropTypes.object.isRequired,
  /** The content of this component */
  children: PropTypes.any
};
export default TypographyWidthHolder;
var _StyledP = _styled("p").withConfig({
  displayName: "TypographyWidthHolder___StyledP",
  componentId: "sc-1w3u24s-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=TypographyWidthHolder.js.map